import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-pre-loaders',
	templateUrl: './pre-loaders.component.html',
	styleUrls: ['./pre-loaders.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class PreLoadersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/pre-loaders/pre-loaders.component.ts